// Das Plattform-Audit: was Plattform-Admins getan haben — jede Anmeldung in
// einen Mandanten und jede Impersonation eingeschlossen (docs/11 10).

import { useInfiniteQuery } from "@tanstack/react-query";
import { get } from "../api/client";
import { keys } from "../api/queries";
import type { AuditPage } from "../api/types";
import { PageHead } from "../app/page-head";
import { fmtDate } from "../lib/format";
import { PLATFORM_EVENT } from "../lib/labels";
import { Link, useSearchParams } from "../router/router";
import { ErrorNote } from "../ui/badge";
import { Card } from "../ui/card";

export function AuditView() {
  const tenant = useSearchParams().get("tenant") ?? "";
  const query = useInfiniteQuery({
    queryKey: keys.audit(tenant),
    queryFn: ({ pageParam }) => {
      const qs = new URLSearchParams();
      if (pageParam !== null) qs.set("before_id", String(pageParam));
      if (tenant) qs.set("tenant", tenant);
      return get<AuditPage>(`/audit?${qs}`);
    },
    initialPageParam: null as string | number | null,
    getNextPageParam: (last) => last.next_before_id ?? undefined,
  });
  const entries = query.data?.pages.flatMap((p) => p.entries) ?? [];
  return (
    <>
      <PageHead
        title="Plattform-Audit"
        hint={<>Das Gegenstück zu dem, was der Kunde in seinem Audit-Log sieht.{tenant ? <> Gefiltert: <code>{tenant}</code> · <Link to="/audit">alle</Link></> : null}</>}
      />
      {query.isError ? <ErrorNote error={query.error} /> : null}
      {query.data ? (
        <Card
          title={`${entries.length} Einträge`}
          flush
          foot={query.hasNextPage
            ? <button type="button" className="pf-btn pf-btn--sm" disabled={query.isFetchingNextPage} onClick={() => void query.fetchNextPage()}>Ältere laden</button>
            : null}
        >
          <div className="pf-table-wrap">
            <table className="pf-table">
              <thead><tr><th>Zeit</th><th>Wer</th><th>Was</th><th>Mandant</th><th className="pf-hide-phone">Details</th></tr></thead>
              <tbody>
                {entries.length ? entries.map((e) => (
                  <tr key={e.id}>
                    <td className="pf-sub">{fmtDate(e.created_at)}</td>
                    <td>{e.actor_name || e.actor_email}<div className="pf-sub">{e.actor_email}{e.ip ? ` · ${e.ip}` : ""}</div></td>
                    <td>{PLATFORM_EVENT[e.event] ?? e.event}</td>
                    <td>{e.tenant_slug ? <Link to={`/audit?tenant=${encodeURIComponent(e.tenant_slug)}`}>{e.tenant_slug}</Link> : "—"}</td>
                    <td className="pf-hide-phone"><span className="mono pf-sub">{JSON.stringify(e.details ?? {}).slice(0, 240)}</span></td>
                  </tr>
                )) : <tr><td colSpan={5} className="pf-empty">Keine Einträge</td></tr>}
              </tbody>
            </table>
          </div>
        </Card>
      ) : null}
    </>
  );
}
